<div class="layout-column full-height">

  <!--Table-->
  <div class="flex layout-column bringoz-table">

    <!--Table Headers-->
    <div id="header" class="layout-row layout-align-start-center tr text-uppercase">
      <div class="th small flex">{{'Contact Name' | translate }}</div>
      <div class="th small flex">{{'Contact Type' | translate }}</div>
      <div class="th small flex layout-row layout-align-start-center">
        <span class="flex">{{'Phone Number' | translate }}</span>
        <bringoz-button *ngIf="canEdit"
                        type="tertiary"
                        size="fit"
                        (onClick)="onEdit.emit($event)">
          <bringoz-icon iconName="edit-outline"></bringoz-icon>
        </bringoz-button>
      </div>
    </div>

    <!--Table Body-->
    <div class="flex layout-column overflow-auto table-body">

      <app-bringoz-operational-contacts-table-row *ngFor="let operationalContact of operationalContacts"
                                                  [operationalContact]="operationalContact">

      </app-bringoz-operational-contacts-table-row>

    </div>

  </div>


</div>

